import { Map, Record } from 'immutable';

import { SubscriptionDatablockItemEntity } from '../components/subscription-configuration-stepper/subscription-datablock-item.entity';
import { SubscriptionProjectItemEntity } from '../components/subscription-configuration-stepper/subscription-project-item.entity';
import { ColumnConfigItemEntity } from '../domain/column-config-item.entity';
import { DatablockColumn } from '../domain/subscription.types';

export const SubscriptionCreatorSliceKey = 'creator';

interface ISubscriptionCreatorSliceState {
	loading: boolean;
	shareableDatablocks: Map<string, SubscriptionDatablockItemEntity>;
	availableColumns: Map<string, ColumnConfigItemEntity>;
	availableProjects: Map<string, SubscriptionProjectItemEntity>;
}

const creatorDefaults: ISubscriptionCreatorSliceState = {
	loading: false,
	shareableDatablocks: Map(),
	availableColumns: Map(),
	availableProjects: Map(),
};

export class SubscriptionCreatorSliceState extends Record<ISubscriptionCreatorSliceState>(
	creatorDefaults
) {
	public setLoading(isLoading: boolean): SubscriptionCreatorSliceState {
		return this.set('loading', isLoading);
	}

	public setShareableDatablocks(
		datablocks: Map<string, SubscriptionDatablockItemEntity>
	): SubscriptionCreatorSliceState {
		return this.set('shareableDatablocks', datablocks);
	}

	public updateDatablockListWithColumns(
		datablockId: number,
		columns: Array<DatablockColumn>
	): SubscriptionCreatorSliceState {
		const selectedDatablock = this.shareableDatablocks.get(`${datablockId}`);
		if (!selectedDatablock) {
			return this;
		}

		const updatedDatablock = selectedDatablock.setColumns(columns);

		const updated = this.shareableDatablocks.set(
			`${datablockId}`,
			updatedDatablock
		);
		return this.set('shareableDatablocks', updated);
	}

	public setAvailableColumns(
		columns: Map<string, ColumnConfigItemEntity>
	): SubscriptionCreatorSliceState {
		return this.set('availableColumns', columns);
	}

	public setAvailableProjects(
		projects: Map<string, SubscriptionProjectItemEntity>
	): SubscriptionCreatorSliceState {
		return this.set('availableProjects', projects);
	}
}
